export enum SubscriptionType {
  MODULE = 'module',
  SERIES = 'series',
}
